import { PrefetchLink } from "@boundary/components/prefetchLink";
import { UserAvatar } from "@boundary/components/userAvatar";
import styles from "./profileLink.module.scss";

function formatPhoneNumber(number: string): string {
  const digits = number.replace(/\D/g, "");

  if (
    digits.length !== 11 ||
    (!digits.startsWith("7") && !digits.startsWith("8"))
  ) {
    return number;
  }

  return `+7 (${digits.substring(1, 4)}) ${digits.substring(4, 7)} ${digits.substring(7, 9)}-${digits.substring(9)}`;
}

interface ProfileLinkProps {
  phone: string;
  photo?: string | null;
  name?: string | null;
}

export function ProfileLink({ phone, photo, name }: ProfileLinkProps) {
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <span className={styles.title}>Профиль</span>
        <span className={styles.phone}>{formatPhoneNumber(phone)}</span>
      </div>
      <UserAvatar photo={photo} name={name} size="small" className={styles.avatar} />
      <PrefetchLink to="/profile" className={styles.link} />
    </div>
  );
}
